module.exports = __webpack_public_path__ + "static/media/Jeremy.95a8e8cc.JPG";